import { useMutation } from '@tanstack/react-query';

import { TasksApi } from 'api/TasksApi';
import { FI_TASK_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries/useUser';
import type { TaskAssignee } from 'ui/apps/fi/tasks/components/tasks-modal.model';
import { TaskAssigneeType } from 'ui/apps/fi/tasks/components/tasks-modal.model';
import { useFiTaskCache } from '../useFiTaskCache';

export function useReassignFiTasks() {
  const { userBankId } = useUser();
  const { invalidateTaskDetails, applyTaskUpdates } = useFiTaskCache();
  const tasksApi = new TasksApi();

  const { mutateAsync: reassignFiTasks, isPending: isReassignFiTasksPending } = useMutation({
    mutationKey: [FI_TASK_KEY],
    mutationFn: ({ taskIds, assignee }: { taskIds: string[]; assignee: TaskAssignee }) =>
      tasksApi.bulkUpdateTasks(
        userBankId,
        taskIds,
        assignee.type === TaskAssigneeType.USER ? [assignee.id] : undefined,
        assignee.type === TaskAssigneeType.GROUP ? [assignee.id] : undefined
      ),
    onSuccess: (updatedTasks, { taskIds }) => {
      applyTaskUpdates(updatedTasks);
      invalidateTaskDetails(taskIds);
    },
    meta: {
      snackbarSuccessMessage: 'Tasks reassigned successfully.',
      snackbarErrorMessage: 'There was a problem reassigning the tasks. Please try again or contact support.'
    }
  });

  return { reassignFiTasks, isReassignFiTasksPending };
}
